import { getSubscriptionDetails } from "../../utilities/orgPanelApiCalls";
import { useEffect, useState } from "react";
import SubscriptionDetails from './SubscriptionDetails'

export default function SubscriptionDetailsViewModel({isOpen, orgId, subscriptionId, target, toggle }) {
    const [isLoading, setIsLoading] = useState(true);
    const [subscriptionData, setSubscriptionData] = useState(null);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
 

    useEffect(() => {
        async function load() {
            if (!isOpen)
                return;

            setIsLoading(true);
            var subscriptionPromise = getSubscriptionDetails(orgId);
            var subscriptionResult = await subscriptionPromise;

            if (subscriptionResult.status > 299) {
                console.log("Failed to load subscription!");
                setShowErrorMessage(true);
            }
            else {
                setSubscriptionData(subscriptionResult.data)
                setShowErrorMessage(false);
            }

            setIsLoading(false);
        }
        load();

    }, [orgId, isOpen]);

    return (
        <SubscriptionDetails
            target={target}
            orgId={orgId}
            isOpen={isOpen}
            isLoading={isLoading}
            subscriptionData={subscriptionData}
            showErrorMessage={showErrorMessage}
            toggle={toggle}
        />
    );

};